import { get } from 'lodash';

const styles = ({ color, fontSize, typography }) => ({
  productGroupPanel: {
    color: get(color, 'pageTitle'),
  },
  accordionTitleBold: {
    fontWeight: 700,
    fontSize: `${get(fontSize, 'bodyText')} !important`,
  },
  accordionTitle: {
    fontSize: `${get(fontSize, 'bodyText')} !important`,
  },
  panelContent: {
    color: `${get(color, 'bodyText')} !important`,
    fontFamily: `${get(typography, 'bodyText')} !important`,
    fontSize: `${get(fontSize, 'bodyText')} !important`,
    fontWeight: 400,
    lineHeight: 1.5,
    height: 300,
    width: '100%',
    overflowY: 'scroll',
  },
});

export default styles;
